export default (dividend, divisor) => ((dividend % divisor) + divisor) % divisor;
